export const initialUrl = '/user-profile'; // this url will open after login
export const appMode =
  process.env.NODE_ENV === 'production' ? 'production' : 'development';
